<template>
  <BasePage title="Logging in...">
    <div class="columns is-desktop ">
    </div>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import { focus } from '../directives.js'

import store from '../store.js'

export default {
  name: 'MagicLogin',
  data () {
    return {
      email: '',
      password: '',
    }
  },
  props: {
    magicToken: {
      type: String,
      required: true,
    },
  },
  components: {
    BasePage,
  },
  mounted () {
    const { magicToken } = this
    store.commit('notify', { message: 'You are using a magic link to login!', level: 'warning' })
    store.dispatch('magicLogin', { magicToken })
  },
  computed: {
    error () {
      return store.state.loginErrorMessage !== ''
    },
    errorMessage () {
      return store.state.loginErrorMessage
    },
  },
  directives: {
    focus,
  },
}
</script>

<style lang="scss">

@import '../_variables.scss';

.login-error {
  color: $DANGER;
  transition: all 0.5 ease;
  text-align: center;
  font-style: italic;
}

</style>



// WEBPACK FOOTER //
// MagicLogin.vue?0b056d68